import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { ToastrService } from 'ngx-toastr';
import { EducationalForumService } from '../../../../../core/services/educational-forum.service';
import { ProfessorAcademicClassroomService } from '../../../../../core/services/professor-academic-classroom.service';
import { AppErrorShow } from '../../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../../core/utils/app-sweet-alert';
import { LocalStorageService } from '../../../../../core/utils/local-stoarge-service';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { HeaderComponent } from '../../../../admin/layout/includes/header/header.component';
import { EducationalForumListComponent } from '../../../../components/educational-forum-list/educational-forum-list.component';

@Component({
    selector: 'app-educational-forum',
    templateUrl: './educational-forum.component.html',
    imports: [
        EducationalForumListComponent,
        CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule
    ],
    styleUrls: ['./educational-forum.component.css']
})
export class EducationalForumComponent {
  vue="list"
  buttonsPermission :any|undefined;
 search_text=""
  classrooms:any[] =[]
  roles:any[] =[]
  data:any[] =[]
  ays:any[] =[]
  selected_data:any;
  modalOption:any; 
  fileInput:any; 
  classroomId:any
  ayId:any
  isDtInitialized:boolean = false
  is_active=null
  loading=false
  tag="professors-educational-forum"
  pg={
    pageSize:10,
    p:0,
    total:0
  }
  role:any
  user:any


  constructor(
    private efService:EducationalForumService,
    private pacService:ProfessorAcademicClassroomService,
    private toastrService:ToastrService,
      config: NgbModalConfig,
      private lsService:LocalStorageService,
    private modalService: NgbModal) {
     config.backdrop = 'static';
     config.keyboard = false;
     }


  ngOnInit(): void {
    this.init()
    this.getActions()
  }

  init(){
    this.professorAcademicClassroomList()
  }

 

  getEducationalResource(){
    this.efService.getByProfessorClassroom(this.classroomId,this.ayId).subscribe((res:any)=>{
      this.data=res.data
      this.modalService.dismissAll()
    },
    (err:any)=>{
AppErrorShow.showError("Nos foras",err)
    })
  }

  professorAcademicClassroomList(){
    this.pacService.getProfessorAcademicClassrooms().subscribe((res:any)=>{
      this.classrooms=res.data
      this.modalService.dismissAll()
    },
    (err:any)=>{
AppErrorShow.showError("Nos foras",err)
    })
  }
  

  loadlist1(e:any){
    this.classroomId=e.target.value
    if (this.classroomId!= undefined && this.ayId!=undefined) {
      this.getEducationalResource()
    }
   
  }
  loadlist2(e:any){
    this.ayId=e.target.value
    if (this.classroomId!= undefined && this.ayId!=undefined) {
      this.getEducationalResource()
    }
  }


  store(value:any){
    this.loading=true

    if (this.fileInput==undefined) {
      this.toastrService.warning('Le document est requis')

      return ;
    }

    let formData= new FormData()

    for (const key in value) {
      if (Object.prototype.hasOwnProperty.call(value, key)) {
        const element = value[key];
          formData.append(key,element)
      }
    }

    formData.append("doc_filename",this.fileInput)

   
    
    this.efService.store(formData).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.modalService.dismissAll()
        this.getEducationalResource()

    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Nos foras",err)

    })
  }
  update(value:any){
    this.loading=true

    this.efService.update(this.selected_data.id,value).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Nos foras",err)

    })
  }
  delete(){
    if(!this.verifyIfElementChecked()) return ;
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.efService.delete(this.selected_data.id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
    },
    (err:any)=>{
      console.log(err)
        AppErrorShow.showError("Nos foras",err)

    })
  }
})
  }
  checked(el?:any){
    this.selected_data=el;
    this.is_active=el.is_active
  }
  verifyIfElementChecked(){
    console.log(this.selected_data)
    if (this.selected_data==null) {
      this.toastrService.warning("Aucun élément selectionné");
      return false;
    }
    return true;
  }



  dismiss(){
    this.modalService.dismissAll()
  }

  add(content:any){
    this.modalService.open(content,{size:'lg'});
  }


  show(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalOption={centered:false,size:"lg"}
    this.modalService.open(content,{size:'lg'});
  }

  edit(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalService.open(content,{size:'lg'});

  }

  setStatus(value:any){

    this.toastrService.warning("Opération en cours")
  
        this.efService.setState(this.selected_data.id,value).subscribe((res:any)=>{
          this.toastrService.success(res.message)
      },
      (err:any)=>{
        console.log(err)
          AppErrorShow.showError("Nos foras",err)

      })
  }

  getActions(){
    // this.buttonsPermission = {
    //   show:AppActionCheck.check(this.tag,'Consultation'),
    //   add:AppActionCheck.check(this.tag,'ajout'),
    //   edit:AppActionCheck.check(this.tag,'edition'),
    //   delete:AppActionCheck.check(this.tag,'suppression'),
    //   status:AppActionCheck.check(this.tag,'statut')
    // };
    this.buttonsPermission={
      show:false,
      add:true,
      edit:true,
      delete:true,
      status:true,
    }
  }



  changeView(event:any){
    this.vue=event.target.value
  }

  upload(ev:any){
    if (ev.target.files.length!=0) {
      this.fileInput=ev.target.files[0]
    }
  }

}
